import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import actions from "@/actions";
import { ScheduleItem } from "@/components/list/Schedule/types";
import storageManager from "@/lib/storageManager";
import { RootState } from "@/reducers/types";

export const useNoteEditor = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // 予定表項目情報
  const scheduleFields = useSelector((state: RootState) => state.schedule.fields);
  const [note1Label, note2Label, note3Label] = useMemo(() => {
    const locale = storageManager.getLocale();
    let note1Label = "";
    let note2Label = "";
    let note3Label = "";
    scheduleFields.forEach((field) => {
      if (field.field_key === "note1") {
        note1Label = locale === "ja" ? field.field_label_jp : field.field_label_en;
      }
      if (field.field_key === "note2") {
        note2Label = locale === "ja" ? field.field_label_jp : field.field_label_en;
      }
      if (field.field_key === "note3") {
        note3Label = locale === "ja" ? field.field_label_jp : field.field_label_en;
      }
    });
    return [note1Label, note2Label, note3Label];
  }, [scheduleFields]);

  const [item, setItem] = useState<ScheduleItem>();
  const [target, setTarget] = useState("");

  const enter = (props: { item: ScheduleItem; target: string }) => {
    setItem(props.item);
    setTarget(props.target);
  };

  const exit = () => {
    setItem(null);
    setTarget(null);
  };

  const submit = (value?: string, e?: HTMLTextAreaElement) => {
    // Validation
    if (["note1", "note2", "note3"].includes(target) && 500 < (value || "").length) {
      const field =
        target === "note1"
          ? note1Label || `${t("construction")}${t("supervising_section")}${t("comments")}`
          : target === "note2"
          ? note2Label || `${t("facility")}${t("supervising_section")}${t("comments")}`
          : note3Label || `${t("primary_charge")}${t("comments")}`;
      dispatch(
        actions.app.showAlert(t("error"), [t("is_too_long_max", { field, length: 500 })], () =>
          dispatch(actions.app.hideAlert())
        )
      );
      e?.focus();

      return;
    }

    const request = {
      input: {
        schedule_task_id: item.schedule_task_id,
        target,
        value,
        update_date: item[`${target}_update_date`] ?? item.timestamp.update_date,
      },
    };
    dispatch(actions.schedule.updateSchedule(request));
    exit();
  };

  return { id: item?.schedule_task_id, target, enter, exit, submit };
};
